import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { AccountCentreService } from '../account-centre.service';
import { UpdatePasswordRequest } from '../../models/account-centre/update-password-request.model';
import { CommonModule } from '@angular/common';
import { passwordValidator } from '../../utility/passwordValidator';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-update-password',
  standalone: true,
  imports: [ButtonModule, InputTextModule, PasswordModule, CalendarModule, ReactiveFormsModule, DropdownModule, CommonModule],
  templateUrl: './update-password.component.html',
  styleUrl: './update-password.component.scss'
})
export class UpdatePasswordComponent {
  updatePasswordForm!: FormGroup;
  submitted = false;
  loading = false;

  constructor(private fb: FormBuilder, private accountCentreService: AccountCentreService,private messageService: MessageService) {
    this.buildForm();
  }
  buildForm() {
    this.updatePasswordForm = this.fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, passwordValidator()]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordsMatchValidator });
  }

  passwordsMatchValidator(form: FormGroup) {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { passwordMismatch: true };
  }

  onSubmit() {
    this.submitted = true;
    if (this.updatePasswordForm.invalid) {
      return;
    }
    this.loading = true;
    const { oldPassword, newPassword } = this.updatePasswordForm.value;
    this.accountCentreService.updatePassword({ oldPassword, newPassword } as UpdatePasswordRequest).subscribe({
      next: () => {
        this.loading = false;
        this.updatePasswordForm.reset();
        this.submitted = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to update password.' });
      }
    });
  }
}
